import { useQuery } from "@tanstack/react-query"
import { useCiphers } from "./use-ciphers"
import { useSession } from "#/lib/auth/session-context"
import {
  getUserProfileQueryKey,
  useGetUserProfile,
} from "#/lib/api/react-query/useGetUserProfile"
import type { GetUserProfilePathParams } from "#/lib/api/types/GetUserProfile"
import { decryptOtherProfile } from "./use-follow"

/** useYourProfile returns the decrypted profile data */
export function useOthersProfile(id: GetUserProfilePathParams["id"]) {
  const { session } = useSession()
  const { data: ciphers } = useCiphers()
  const { data } = useGetUserProfile(id, {
    query: {
      enabled: !!session && !!ciphers,
    },
  })

  return useQuery({
    queryKey: [
      getUserProfileQueryKey(id)[0],
      "decrypted",
      data,
      ciphers?.rsaPrivateKey,
    ],
    queryFn: () => {
      if (!data?.profile || !ciphers?.rsaPrivateKey) {
        throw new Error("impossible state")
      }
      return decryptOtherProfile(
        data?.profile,
        data?.protectedProfileSymmetricKey,
        ciphers?.rsaPrivateKey,
      )
    },
    enabled:
      !!ciphers && !!data?.profile && !!data?.protectedProfileSymmetricKey,
  })
}
